import { useState } from "preact/hooks";
import { toast } from "react-hot-toast";
import { apiClient } from "../../constants.ts";
import {
  Button,
  Collapsible,
  CopyableValue,
  inputClass,
  labelClass,
  PageSpinner,
  TokenDisplay,
} from "./components.tsx";
import { useAuth, useQuery } from "./db.ts";

export const ForwardEmailConfig = ({ id }: { id: string }) => {
  const [newApiKey, setNewApiKey] = useState("");
  const [newFromAddress, setNewFromAddress] = useState("");
  const [editing, setEditing] = useState(false);
  const token = useAuth().user?.refresh_token;
  const { data, error, isLoading } = useQuery({
    bots: { $: { where: { id } } },
  });
  if (isLoading) return <PageSpinner />;
  if (error) return <div>Error: {error.message}</div>;
  const { bots } = data;
  const [bot] = bots;
  const { forwardEmailApiKey, forwardEmailFromAddress } = bot || {};
  if (!bot) return <div>No bot found</div>;
  const isConfigured = forwardEmailApiKey && forwardEmailFromAddress;
  const showForm = !isConfigured || editing;
  return (
    <Collapsible title="Forward Email">
      <div className="flex flex-col gap-4">
        {showForm
          ? (
            <div className="flex flex-col gap-3">
              <div>
                <label className={labelClass}>API Key</label>
                <input
                  value={newApiKey}
                  onChange={(e) => setNewApiKey(e.currentTarget.value)}
                  className={inputClass}
                />
              </div>
              <div>
                <label className={labelClass}>From Email Address</label>
                <input
                  value={newFromAddress}
                  onChange={(e) => setNewFromAddress(e.currentTarget.value)}
                  className={inputClass}
                  placeholder="no-reply@yourdomain.com"
                />
              </div>
              <div className="flex gap-2">
                <Button
                  onClick={() => {
                    if (!token) return;
                    toast.promise(
                      apiClient({
                        token,
                        endpoint: "set-forward-email",
                        payload: {
                          botId: bot.id,
                          apiKey: newApiKey,
                          fromAddress: newFromAddress,
                        },
                      }).then((res) => {
                        if (!res.success) throw new Error(res.error);
                        setNewApiKey("");
                        setNewFromAddress("");
                        setEditing(false);
                      }),
                      {
                        loading: "Connecting email...",
                        success: "Email connected!",
                        error: (err) =>
                          `Failed to connect email: ${err.message}`,
                      },
                    );
                  }}
                  disabled={!newApiKey || !newFromAddress}
                  className="w-full md:w-auto"
                >
                  Connect Email
                </Button>
                {editing && (
                  <Button
                    onClick={() => {
                      setEditing(false);
                      setNewApiKey("");
                      setNewFromAddress("");
                    }}
                    className="w-full md:w-auto"
                  >
                    Cancel
                  </Button>
                )}
              </div>
            </div>
          )
          : (
            <div className="flex flex-col gap-3">
              <TokenDisplay label="API Key" token={forwardEmailApiKey} />
              <CopyableValue
                label="From Address"
                value={forwardEmailFromAddress}
              />
              <Button
                onClick={() => setEditing(true)}
                className="w-full md:w-auto"
              >
                Reconfigure
              </Button>
            </div>
          )}
      </div>
    </Collapsible>
  );
};
